import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import i18next from "i18next";
import { http, HttpResponse } from "msw";
import { runInAction } from "mobx";
import SenapsLocationsCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/SenapsLocationsCatalogItem";
import Terria from "../../../../lib/Models/Terria";
import { worker } from "../../../mocks/browser";
import locationsJson from "../../../../wwwroot/test/Senaps/locations.json";
import locationsFilteredJson from "../../../../wwwroot/test/Senaps/locations_filtered.json";
import streamsJson from "../../../../wwwroot/test/Senaps/streams.json";
import streamsFilteredJson from "../../../../wwwroot/test/Senaps/streams_filtered.json";
describe("SenapsLocationsCatalogItem", function () {
  let terria;
  let item;
  let geoJsonItem;
  let geoJsonData;
  let feature;
  const altProxyUrl = "/api/v0/data/proxy/a-record-id";
  const senapsCatalogItemUrl = "https://senaps.io/api/sensor/v2";
  const altProxiedBaseUrl = "".concat(altProxyUrl, "/").concat(senapsCatalogItemUrl);
  const defaultProxiedBaseUrl = "".concat(senapsCatalogItemUrl);
  function getExpectedFeatureInfoTemplate(url) {
    const expectedFeatureInfoTemplate = "<h4>".concat(i18next.t("models.senaps.locationHeadingFeatureInfo"), ": {{id}}</h4>\n      <h5 style=\"margin-bottom:5px;\">").concat(i18next.t("models.senaps.availableStreamsHeadingFeatureInfo"), "</h5>\n      {{#hasStreams}}\n      <ul>{{#streamIds}}\n      <li>{{.}}</li>\n      {{/streamIds}}</ul>\n      <br/>\n      <chart\n      identifier='{{id}}'\n      title='{{id}}'\n      sources='").concat(url, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=1440&media=csv&csvheader=false&sort=descending,").concat(url, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=7200&media=csv&csvheader=false&sort=descending'\n      source-names='1d,5d'\n      downloads='").concat(url, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=1440&media=csv&csvheader=false&sort=descending,").concat(url, "/observations?streamid={{#terria.urlEncodeComponent}}{{streamIds}}{{/terria.urlEncodeComponent}}&limit=7200&media=csv&csvheader=false&sort=descending'\n      download-names='1d,5d'\n      >\n      </chart>\n      {{/hasStreams}}\n      {{^hasStreams}}\n      <br/><br/>\n      {{/hasStreams}}\n      ").split(" ").join("");
    return expectedFeatureInfoTemplate;
  }
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    item = new SenapsLocationsCatalogItem("test", terria);
    item.setTrait("definition", "url", senapsCatalogItemUrl);
    worker.use(http.get("*/locations", _ref => {
      let {
        request
      } = _ref;
      const url = new URL(request.url);
      if (url.searchParams.has("id")) return HttpResponse.json(locationsFilteredJson);
      return HttpResponse.json(locationsJson);
    }), http.get("*/streams", _ref2 => {
      let {
        request
      } = _ref2;
      const url = new URL(request.url);
      if (url.searchParams.has("id")) return HttpResponse.json(streamsFilteredJson);
      return HttpResponse.json(streamsJson);
    }));
  });
  it("- has a type and typename", function () {
    expect(item.type).toBe("senaps-locations");
    expect(item.typeName).toBe(i18next.t("models.senaps.name"));
  });
  it("- supports zooming to extent", function () {
    expect(item.disableZoomTo).toBeFalsy();
  });
  it("- supports show info", function () {
    expect(item.disableAboutData).toBeFalsy();
  });
  describe("Can not get any items without base url", function () {
    beforeEach(function () {
      runInAction(() => {
        item = new SenapsLocationsCatalogItem("test", new Terria());
      });
    });
    it("- fail to construct locations url", async function () {
      function foundError() {
        let errorMessage = "";
        try {
          item._constructLocationsUrl();
        } catch (e) {
          errorMessage = e.message;
        }
        return errorMessage === i18next.t("models.senaps.missingSenapsBaseUrl");
      }
      expect(foundError()).toBe(true);
    });
    it("- fail to construct streams url", async function () {
      function foundError() {
        let errorMessage = "";
        try {
          item._constructStreamsUrl("123");
        } catch (e) {
          errorMessage = e.message;
        }
        return errorMessage === i18next.t("models.senaps.missingSenapsBaseUrl");
      }
      expect(foundError()).toBe(true);
    });
  });
  describe("Can get all items via implicitly specified proxy", function () {
    beforeEach(async function () {
      runInAction(() => {
        item = new SenapsLocationsCatalogItem("test", new Terria());
        item.setTrait("definition", "url", altProxiedBaseUrl);
      });
      await item.loadMapItems();
      geoJsonItem = item.geoJsonItem;
      geoJsonData = geoJsonItem.geoJsonData;
      feature = geoJsonData.features[0];
    });
    it("- constructs correct locations url", function () {
      expect(item._constructLocationsUrl()).toBe("".concat(altProxiedBaseUrl, "/locations?count=1000&expand=true"));
    });
    it("- constructs correct streams url", function () {
      expect(item._constructStreamsUrl("123")).toBe("".concat(altProxiedBaseUrl, "/streams?locationid=123"));
    });
    it("- creates correct feature info template", function () {
      var _item$featureInfoTemp;
      const actualFeatureInfoTemplate = ((_item$featureInfoTemp = item.featureInfoTemplate.template) === null || _item$featureInfoTemp === void 0 ? void 0 : _item$featureInfoTemp.split(" ").join("")) || "";
      expect(actualFeatureInfoTemplate).toBe(getExpectedFeatureInfoTemplate(altProxiedBaseUrl));
    });
    it("- has the right number of features", function () {
      expect(item.geoJsonItem).toBeDefined();
      expect(geoJsonData).toBeDefined();
      expect(geoJsonData.features.length).toEqual(2);
    });
    it("- has a feature with the right properties", function () {
      expect(feature.geometry.coordinates).toEqual([148.699683, -34.470083]);
      expect(feature.properties).toBeDefined();
      expect(feature.properties.id).toBe("boorowa.temprh.site5a");
      expect(feature.properties.description).toBe("Boorowa TempRH Site5a");
      expect(feature.properties.hasStreams).toBe(true);
      expect(feature.properties.streamIds).toEqual(["tdfnode.0.323831395a368714-99.SHT31DIS_ALL.temperature", "tdfnode.0.323831395a368714-99.SHT31DIS_ALL.humidity"]);
    });
  });
  describe("Can get all items via default proxy", function () {
    beforeEach(async function () {
      runInAction(() => {
        item = new SenapsLocationsCatalogItem("test", new Terria());
        item.setTrait("definition", "url", senapsCatalogItemUrl);
      });
      await item.loadMapItems();
      geoJsonItem = item.geoJsonItem;
      geoJsonData = geoJsonItem.geoJsonData;
      feature = geoJsonData.features[0];
    });
    it("- constructs correct locations url", function () {
      expect(item._constructLocationsUrl()).toBe("".concat(senapsCatalogItemUrl, "/locations?count=1000&expand=true"));
    });
    it("- constructs correct streams url", function () {
      expect(item._constructStreamsUrl("123")).toBe("".concat(senapsCatalogItemUrl, "/streams?locationid=123"));
    });
    it("- creates correct feature info template", function () {
      var _item$featureInfoTemp2;
      const actualFeatureInfoTemplate = ((_item$featureInfoTemp2 = item.featureInfoTemplate.template) === null || _item$featureInfoTemp2 === void 0 ? void 0 : _item$featureInfoTemp2.split(" ").join("")) || "";
      expect(actualFeatureInfoTemplate).toBe(getExpectedFeatureInfoTemplate(defaultProxiedBaseUrl));
    });
    it("- has the right number of features", function () {
      expect(item.geoJsonItem).toBeDefined();
      expect(geoJsonData).toBeDefined();
      expect(geoJsonData.features.length).toEqual(2);
    });
    it("- has a feature with the right properties", function () {
      expect(feature.geometry.coordinates).toEqual([148.699683, -34.470083]);
      expect(feature.properties).toBeDefined();
      expect(feature.properties.id).toBe("boorowa.temprh.site5a");
      expect(feature.properties.description).toBe("Boorowa TempRH Site5a");
      expect(feature.properties.hasStreams).toBe(true);
      expect(feature.properties.streamIds).toEqual(["tdfnode.0.323831395a368714-99.SHT31DIS_ALL.temperature", "tdfnode.0.323831395a368714-99.SHT31DIS_ALL.humidity"]);
    });
  });
  describe("Can get filtered items via default proxy", function () {
    beforeEach(async function () {
      runInAction(() => {
        item = new SenapsLocationsCatalogItem("test", new Terria());
        item.setTrait("definition", "locationIdFilter", "boor");
        item.setTrait("definition", "streamIdFilter", "temp");
        item.setTrait("definition", "url", senapsCatalogItemUrl);
      });
      await item.loadMapItems();
      geoJsonItem = item.geoJsonItem;
      geoJsonData = geoJsonItem.geoJsonData;
      feature = geoJsonData.features[0];
    });
    it("- constructs correct locations url", function () {
      expect(item._constructLocationsUrl()).toBe("".concat(senapsCatalogItemUrl, "/locations?id=boor&count=1000&expand=true"));
    });
    it("- constructs correct streams url", function () {
      expect(item._constructStreamsUrl("123")).toBe("".concat(senapsCatalogItemUrl, "/streams?id=temp&locationid=123"));
    });
    it("- creates correct feature info template", function () {
      var _item$featureInfoTemp3;
      const actualFeatureInfoTemplate = ((_item$featureInfoTemp3 = item.featureInfoTemplate.template) === null || _item$featureInfoTemp3 === void 0 ? void 0 : _item$featureInfoTemp3.split(" ").join("")) || "";
      expect(actualFeatureInfoTemplate).toBe(getExpectedFeatureInfoTemplate(defaultProxiedBaseUrl));
    });
    it("- only retrieves matching features", function () {
      expect(item.geoJsonItem).toBeDefined();
      expect(geoJsonData.type).toEqual("FeatureCollection");
      expect(geoJsonData.features.length).toEqual(1);
    });
    it("- only retrieves matching streams", function () {
      expect(feature.properties.streamIds.length).toEqual(1);
    });
  });
  describe("Can get filtered items via implicitly specified alternative proxy", function () {
    beforeEach(async function () {
      runInAction(() => {
        item = new SenapsLocationsCatalogItem("test", new Terria());
        item.setTrait("definition", "locationIdFilter", "boor");
        item.setTrait("definition", "streamIdFilter", "temp");
        item.setTrait("definition", "url", altProxiedBaseUrl);
      });
      await item.loadMapItems();
      geoJsonItem = item.geoJsonItem;
      geoJsonData = geoJsonItem.geoJsonData;
      feature = geoJsonData.features[0];
    });
    it("- constructs correct locations url", function () {
      expect(item._constructLocationsUrl()).toBe("".concat(altProxiedBaseUrl, "/locations?id=boor&count=1000&expand=true"));
    });
    it("- constructs correct streams url", function () {
      expect(item._constructStreamsUrl("123")).toBe("".concat(altProxiedBaseUrl, "/streams?id=temp&locationid=123"));
    });
    it("- creates correct feature info template", function () {
      var _item$featureInfoTemp4;
      const actualFeatureInfoTemplate = ((_item$featureInfoTemp4 = item.featureInfoTemplate.template) === null || _item$featureInfoTemp4 === void 0 ? void 0 : _item$featureInfoTemp4.split(" ").join("")) || "";
      expect(actualFeatureInfoTemplate).toBe(getExpectedFeatureInfoTemplate(altProxiedBaseUrl));
    });
    it("- only retrieves matching features", function () {
      expect(item.geoJsonItem).toBeDefined();
      expect(geoJsonData.type).toEqual("FeatureCollection");
      expect(geoJsonData.features.length).toEqual(1);
    });
    it("- only retrieves matching streams", function () {
      expect(feature.properties.streamIds.length).toEqual(1);
    });
  });
});